<template>
  <page-outline :title="$t('bank_accounts.bnk_act_lst')">
    <template slot="pageContent">
  <!-- App -->
  <!-- <f7-page class="" id="contacts"> -->
  <!--<div class="page rowBackgroundHomepage">-->
    <!--bottom-toolbar></bottom-toolbar-->


      <!--<div class="page-content">
        <div class="layoutTop" v-if="!isSmartphoneOS"></div>
        <div style="height:88px;" v-else></div>-->
        <div class="listPage">
          <div class="d-flex form-group justify-content-start showLargeScreenOnly mb-27px">
            <div sm="2" class="mr-3">
              <b-button size="sm"
                :disabled="$engine.rights.rightIs('bank_account_ajouter', false)"
                @click="openFormsPage()">
                <span>{{ $t('common.add_label') }}</span>
              </b-button>
            </div>
            <!--DRO 07/06/2023 : Commenté car non pertinent pour le moment
            <b-col sm="2">
              <b-button class="" size="sm"
                :disabled="$engine.rights.rightIs('bank_account_ajouter', false)"
                @click="openFormsImportPage()">
                <span>{{ $t('common.imprt') }}</span>
              </b-button>
            </b-col>
            -->
            <div sm="2">
              <b-button class="mr-3" size="sm"
                @click="openFormListStatement()">
                <span>{{ $t('bank_accounts.view_statements') }}</span>
              </b-button>
            </div>
            <!--DRO 07/06/2023 : Commenté car non pertinent pour le moment
            <b-col sm="2">
              <b-button class="" size="sm" style="width: 4cm;"
                @click="linkRapprochement()">
                <span>{{ $t('bank_accounts.rcncltn') }}</span>
                <span v-if="nbOperations" class="new-badge badge-danger">{{nbOperations}}</span>
              </b-button>
            </b-col>
            -->
          </div>

          <div class="layoutSubtitle"/>

          <!--<f7-list class="searchbar-found" id="search-list">-->
          <spinner v-if="activateSpinner"></spinner>
          <!-- <cm-bank-accounts-list v-else :bankAccounts="bankAccounts" :filterBy="filterBy"> -->
          <!-- </cm-bank-accounts-list> -->
          <div v-else>
            <b-table hover fixed responsive
              v-if="bankAccounts.length"
              class="table-condensed mb-70px table-striped"
              :items="bankAccounts"
              :fields="fields">
              <template #cell(isDefault)="data">
                <span class="text-center d-inline-block py-4 w-100 color-var-actionButtonColorBlue" @click="setDefaultBanqueAccount(data.item, $event)"><f7-icon :fa="data.item.isDefault === '1' ? 'star' : 'star-o'" size="17px"></f7-icon></span>
              </template>
              <template #cell(edit)="data">
                <span class="text-center d-inline-block py-4 w-100 color-var-actionButtonColorBlue" @click="modifyBanqueAccount(data.item, $event)"><f7-icon fa="fa-light fa-pencil" size="17px" ></f7-icon></span>
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-4 w-100 color-var-actionButtonColorBlue" @click="removeBankAccount(data.item.id, $event)"><f7-icon fa="fa-light fa-trash" size="17px" ></f7-icon></span>
              </template>
              <template #cell()="data">
                <div class="cursor d-inline-block py-4 w-100" @click="openFormListStatementSingle(data.item)">{{ data.value }}</div>
              </template>
            </b-table>
            <label v-else class="font-bold w-100 d-flex justify-content-center mt-3">{{ $t('common.no_result') }}</label>
          </div>
          <!--</f7-list>-->
          <f7-list class="searchbar-not-found">
            <f7-list-item title="Nothing found"></f7-list-item>
          </f7-list>
        </div>
      <!--</div>-->
      <!--</div>-->
      <div class="showSmallScreenOnly mt-5">
        <f7-fab class="leftfav3 button-fab bottomButton" @click="openFormsPage()"
          :disabled="$engine.rights.rightIs('bank_account_ajouter', false)">
          <i class="fa-light fa-grid-2-plus fs-17px"></i>
        </f7-fab>
        <!--DRO 07/06/2023 : Commenté car non pertinent pour le moment
        <f7-fab class="leftfav3 button-fab bottomButton" @click="openFormsImportPage()"
          :disabled="$engine.rights.rightIs('bank_account_ajouter', false)">
          <i class="fa-light fa-file" style="font-size: 17px"></i>
        </f7-fab>
        -->
        <f7-fab class="leftfav2 button-fab bottomButton" @click="openFormListStatement()">
          <i class="fa-light fa-euro-sign fs-17px"></i>
        </f7-fab>
      </div>
<!-- </f7-page> -->
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'

import pagination from '@/components/common/pagination.vue'
import spinner from '@/components/common/spinner.vue'
import PageOutline from '@/components/common/PageOutline.vue'


import BankAccountsList from './CMBankAccountsPage/CMBankAccountsList.vue'

import {loadPage} from '@/helpers/routing'
import { downloadFileWithDefinedHeaders } from '@/helpers/download'

export default {
  name: 'BankAccounts',
  components: {
    'cm-bank-accounts-list': BankAccountsList,
    'cm-pagination': pagination,
    'spinner': spinner,
    'page-outline': PageOutline
  },
  data () {
    return {
      activateSpinner: false,
      bankAccounts: [],
      filterBy: '',
      items: [],
      nbOperations: 0,
      service: ''
    }
  },
  computed: {
    canDeleteBankAccount () {
      return this.$engine.rights.rightIs('bank_account_supprimer', true)
    },
    canEditBankAccount () {
      return this.$engine.rights.rightIs('bank_account_editer', true)
    },
    fields () {
      let nbColAdded = 2
      let fields = [
        { key: 'name', label: this.$t('bank_accounts.bank_account_name'), class: 'text-center text-truncate', tdClass: 'p-0' },
        { key: 'iban', label: this.$t('bank_accounts.bank_account_iban'), class: 'text-center text-truncate', tdClass: 'p-0' },
        { key: 'isDefault', label: this.$t('bank_accounts.default_act_label'), class: 'text-center w-10', tdClass: 'p-0' }
      ]
      if (this.canEditBankAccount) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center w-10', tdClass: 'p-0'})
        nbColAdded--
      }
      if (this.canDeleteBankAccount) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), thClass: 'text-center w-10', tdClass: 'p-0'})
        nbColAdded--
      }
      if (nbColAdded > 0) {
        fields[0].class = 'col-5 text-center'
        if (nbColAdded > 1) {
          fields[1].class = 'col-5 text-center'
        }
      }

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.$i18n.t('Webheader.my_bank_accounts'),
      returnUrl: 'none'
    })
    /* Turn off all buses events */
    // this.$bus.$off('inbox-filtered')
    this.$bus.$off('sendbox-filtered')
    // this.$bus.$off('refresh-cache-service')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    // this.$bus.$off('refresh-cache-attachments-view')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    this.$bus.$off('refresh-inbox-list-cache')
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.$off('refresh-bank-accounts')
    this.$bus.on('refresh-bank-accounts', (index = 1) => {
      this.getBankAccounts(index)
    })

    let that = this
    this.$bus.$on('language-changed', () => {
      that.fields = [
        { key: 'name', label: this.$t('bank_accounts.bank_account_name'), class: 'col-4 text-center' },
        { key: 'iban', label: this.$t('bank_accounts.bank_account_iban'), class: 'col-4 text-center' },
        { key: 'isDefault', label: this.$t('bank_accounts.default_act_label'), class: 'col-2 text-center' }
      ]
      let nbColAdded = 2
      if (that.canEditBankAccount) {
        that.fields.push({ key: 'edit', label: that.$t('rights.edit'), class: 'col-1 text-center' })
        nbColAdded--
      }
      if (that.canDeleteBankAccount) {
        that.fields.push({ key: 'delete', label: that.$t('rights.delete'), class: 'col-1 text-center' })
        nbColAdded--
      }
      if (nbColAdded > 0) {
        this.fields[0].class = 'col-5 text-center'
        if (nbColAdded > 1) {
          this.fields[1].class = 'col-5 text-center'
        }
      }
    })

    this.getBankAccounts()
    this.service = this.$engine.user.currentService.name
  },
  mounted () {
  },
  methods: {
    getBankAccounts (index = 1) {
      // this.bankAccounts = this.$engine.bankAccounts.get()
      let params = {
        idAccount: this.$engine.user.get().id
      }
      // this.bankAccounts = this.$engine.bankAccounts.get()
      this.activateSpinner = true
      this.$engine.bankAccounts.getParams(params).then(response => {
        this.organiserResponse(response)
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    modifyBanqueAccount (account, e) {
      e.stopPropagation()
      this.$bus.emit('edit-bank-account', account)
      // this.$f7.popup('#EditBankAccount')
      this.$engine.settings.set({modifyAccount: account})
      loadPage(this, {url: '/bankAccounts/modify/'})
    },
    organiserResponse (response) {
      var bankAccountsList = []
      let bankAccountsReturn = response.data.bankAccounts
      this.nbOperations = bankAccountsReturn.reduce((acc, account) => [...acc, ...account.needReconciliation.operations], []).length
      for (var j = 0; j < bankAccountsReturn.length; j++) {
        if (bankAccountsReturn[j].name.toLowerCase().includes(this.filterBy.toLowerCase())) {
          bankAccountsList.push(bankAccountsReturn[j])
        }
      }
      this.bankAccounts = bankAccountsList
      this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
      this.activateSpinner = false
    },
    onSearch (query, found) {
      this.filterBy = query
      this.getBankAccounts()
    },
    onClear () {
      this.filterBy = ''
    },
    openFormsPage () {
      loadPage(this, {url: '/bankAccounts/create/'})
    },
    openFormsImportPage () {
      loadPage(this, {url: '/bankAccounts/import/'})
    },
    openFormListStatement () {
      let that = this
      let bankAccounts = that.$engine.bankAccounts.get()
      // let bankAccountsDone = 0
      for (var i in bankAccounts) {
        that.$engine.bankAccounts.getOperationStatements(bankAccounts[i].iban).then(response => {
          if (response.status === 200) {
            let innerBankAccounts = that.$engine.bankAccounts.get()
            for (var innerIndex in innerBankAccounts) {
              if (innerBankAccounts[innerIndex].iban === response.data.iban) {
                innerBankAccounts[innerIndex].balances = response.data.receivedTransfers
              }
              if (innerIndex + 1 === innerBankAccounts.length) {
                that.$engine.bankAccounts.set(bankAccounts)
              }
            }
          }
        })
      }
      that.$engine.bankAccounts.setImportReport('')
      that.$engine.bankAccounts.setIbanStatment('')
      loadPage(that, {url: '/bankAccounts/listStatement/'})
    },
    openFormListStatementSingle (account) {
      this.$engine.bankAccounts.getOperationStatements(account.iban).then(response => {
        if (response.status === 200) {
          let bankAccounts = this.$engine.bankAccounts.get()
          for (var i in bankAccounts) {
            if (bankAccounts[i].iban === response.data.iban) {
              bankAccounts[i].balances = response.data.receivedTransfers
            }
          }
          this.$engine.bankAccounts.set(bankAccounts)
        }
      })
      this.$engine.bankAccounts.setIbanStatment(account.iban)
      this.$bus.emit('refresh-bank-accounts-list-statement')
      loadPage(this, {url: '/bankAccounts/listStatement/'})
    },
    removeBankAccount (id, e) {
      e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$i18n.t('common.oper_confirm'),
        text: this.$i18n.t('bank_accounts.delete_act_confirmation'),
        buttons: [{
          text: this.$t('common.cncl'),
          onClick: this.$f7.closeModal()
        }, {
          text: 'OK',
          onClick: function () {
            that.$engine.bankAccounts
              .del(id)
              .then(() => {
                that.$f7.modal({
                  title: that.$i18n.t('bank_accounts.deleted_act'),
                  text: '<span class="preloader"></span>'
                })
                setTimeout(function () {
                  that.bankAccounts = that.bankAccounts.filter(function (value, index, arr) { return value.id !== id })
                  that.$f7.closeModal()
                  loadPage(that, {url: '/bankAccounts/', force: false, ignoreCache: false})
                }, 2000)
              })
              .catch(err => {
                that.handleError(err) // mixins errorHandlerMixins
              })
          }
        }]
      })
    },
    setDefaultBanqueAccount (account, e) {
      e.stopPropagation()
      if (!this.canEditBankAccount) {
        this.$f7.alert('', this.$t('Impossible de modifier le compte par défaut'))
        return
      }
      let that = this
      let isDefaultValue = ''
      if (account.isDefault === '0') {
        isDefaultValue = '1'
      } else if (account.isDefault === '1') {
        isDefaultValue = '0'
      }
      this.$engine.bankAccounts
        .update({
          id: account.id,
          name: account.name,
          iban: account.iban,
          qxban: '',
          isDefault: isDefaultValue,
          zoneCode: account.zoneCode
        })
        .then(() => {
          that.$f7.modal({
            title: that.$i18n.t('bank_accounts.default_act_setted'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.name = ''
            that.iban = ''
            that.id = 0
            that.$bus.$emit('refresh-bank-accounts')
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
    },
    extractCSV () {
      //console.log('extractCSV lancé')
      let params = {
        firstIndex: 1,
        idAccount: this.$engine.user.get().id
      }
      // this.bankAccounts = this.$engine.bankAccounts.get()
      this.$engine.bankAccounts.getParams(params).then(response => {
        let firstLine = 'id;name;Iban\r\n'
        let lines = ''
        let bankAccounts = response.data.bankAccounts
        for (var account in bankAccounts) {
          lines += bankAccounts[account].id + ';' + bankAccounts[account].name + ';' +
          bankAccounts[account].iban + '\r\n'
        }

        let data = firstLine + lines
        let today = moment()
        // encode 64 résoud le pb du retour à la ligne sur Firefox.
        var linkSource = 'data:text/csv;charset=utf-8;base64,' + btoa(data)
        const downloadLink = document.createElement('a')
        var fileName = ''
        if (this.service === 'Direct Debit') {
          fileName = 'bankAccountModularLoan' + today.unix() + '.csv'
        } else if (this.service === 'Direct Payments') {
          fileName = 'bankAccountDirectPayments' + today.unix() + '.csv'
        } else {
          fileName = 'bankAccountRequestToPay' + today.unix() + '.csv'
        }
        if (
          this.$f7.device.os === 'android' ||
          this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    linkRapprochement () {
      loadPage(this, {url: '/bankAccounts/rapprochement'})
    }
  }
}
</script>
